import { Link } from "react-router-dom";

/**
 * Brand mark + wordmark. SINGLE SOURCE OF TRUTH for the company logo.
 *
 * - Image asset lives in /public/logo.png (and /public/logo-mark.png).
 * - To swap the logo, replace those files only. Do NOT inline the badge anywhere else.
 *
 * Props:
 *   size       — height in px for the logo image (default 28)
 *   showText   — whether to render the wordmark next to the mark (default true)
 *   variant    — "default" (light bg) | "white" (dark bg, white wordmark)
 *   asLink     — wrap in a Link to "/" (default true on landing nav, false in footer)
 *   testId     — data-testid override
 */
export default function Brand({
  size = 28,
  showText = true,
  variant = "default",
  asLink = true,
  to = "/",
  className = "",
  testId = "brand",
}) {
  const textColor = variant === "white" ? "text-white" : "text-[#0A1930]";
  const subColor = variant === "white" ? "text-white/60" : "text-slate-500";
  const content = (
    <span className={`inline-flex items-center gap-2.5 ${className}`} data-testid={testId}>
      <img
        src="/logo.png"
        alt="For Those Who Served logo"
        data-brand-logo
        height={size}
        style={{ height: size, width: "auto" }}
        className="block select-none"
        draggable="false"
      />
      {showText && (
        <span className="flex flex-col leading-none" data-brand-text>
          <span className={`font-display text-[15px] tracking-tight ${textColor}`}>
            For Those Who Served
          </span>
          <span className={`text-[10px] tracking-[0.18em] uppercase mt-0.5 ${subColor}`}>
            Veteran founded · Mission driven
          </span>
        </span>
      )}
    </span>
  );
  if (!asLink) return content;
  return (
    <Link to={to} className="inline-flex items-center" aria-label="For Those Who Served — home">
      {content}
    </Link>
  );
}
